import './Scheduler.css';

import {
  formatLocalizedDateTime,
  formatSchedulerLocalizedDateString,
} from '@saviynt/common';
import { Box } from '@saviynt/design-system';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import { Session } from '../../models/PamModels';
import SchedulerDay from './ScheduleDay/SchedulerDay';

function Scheduler({ sessions, numOfDays, dataTestId, className }) {
  const classes = classnames('Scheduler', className);

  const renderBlock = () => {
    const weekdays = [
      'Sunday',
      'Monday',
      'Tuesday',
      'Wednesday',
      'Thursday',
      'Friday',
      'Saturday',
    ];
    const daysArray = [];

    // +2 days for the exclusion of weekends
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < numOfDays + 2; i++) {
      const currentDate = new Date();

      currentDate.setDate(currentDate.getDate() + i);

      // Weekdays/Business days only
      if (currentDate.getDay() !== 0 && currentDate.getDay() !== 6) {
        daysArray.push(currentDate);
      }
    }

    const getLocalizedDate = (date) =>
      formatLocalizedDateTime(date).split(',')[0];

    return daysArray.map((day) => (
      <Box key={daysArray.indexOf(day)} className='Scheduler-block'>
        <section className='Scheduler-blockLabel'>
          <div className='Scheduler-blockLabel--weekday'>
            {`${
              daysArray.indexOf(day) === 0 ? 'Today' : weekdays[day.getDay()]
            }, `}
          </div>
          <div className='Scheduler-blockLabel--date'>
            {formatSchedulerLocalizedDateString(day)}
          </div>
        </section>
        {sessions.map((session) => {
          if (
            getLocalizedDate(new Date(session.startDate)) ===
            getLocalizedDate(day)
          ) {
            return (
              <SchedulerDay key={sessions.indexOf(session)} session={session} />
            );
          }

          return null;
        })}
        <SchedulerDay />
      </Box>
    ));
  };

  return (
    <section className={classes} data-testid={dataTestId}>
      {renderBlock()}
    </section>
  );
}

Scheduler.propTypes = {
  sessions: PropTypes.arrayOf(Session),
  numOfDays: PropTypes.number,
  dataTestId: PropTypes.string,
  className: PropTypes.string,
};

Scheduler.defaultProps = {
  sessions: null,
  numOfDays: 7,
  dataTestId: null,
  className: null,
};

export default Scheduler;
